import { useState } from 'react';
import './NavbarLower.css';
import { Theme, createStyles, makeStyles, colors } from "@material-ui/core";

import MenuItem from './MenuItem';
import { NavLink, useLocation } from 'react-router-dom';
import { AppBar, Toolbar, Button, Typography, IconButton, Drawer, List, ListItem, ListItemText, useMediaQuery, useTheme } from '@mui/material';
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    fontFamily: 'Helvetica , sans-serif'
  },
  logo: {
    height: 55,
    backgroundColor: '#ffffff',
    alignSelf: 'flex-start'
  },
  active: {
    color: '#290131', // Change the text color here
    backgroundColor: '#f15a24', // Change the background color here
    //textDecoration: 'none',
    fontWeight: 600
  },
  title: {
    color: '#000000',
    fontWeight: 'bold',
    fontSize:20
  }
}));
// Define MobileMenu component
const MobileMenu = () => {
  const classes = useStyles();
  return (
    <div className={'mobile-menu'}>
        <div className={classes.logo}>
           <img alt="Logo" src="/images/logos/logo.png" className={classes.logo} />
        </div>
      {MenuItem.slice(0, 5).map((page) => (
        <div className='menu-section'>
        <NavLink
          to={page.to}
          className={({ isActive }) => isActive ? `${classes.active} navlink` : 'navlink'}
        >
          {page.title}
        </NavLink>

        </div>

      ))}
    </div>
    
  );
};

function NavbarLower() {
  const classes = useStyles();
  const [isShown, setIsShown] = useState(false);
  const toggleMobileMenu = () => {
    setIsShown(!isShown);
  };

  return (
    <>
      <div className='topnav'>
        {/* Your Logo/Brand here */}
        <div className={classes.logo}>
           <img alt="Logo" src="/images/logos/logo.png" className={classes.logo} />
           {/*<img alt="Logo" src="/images/logos/logo.png" className={classes.logo} />*/}
        </div>

        {/* Desktop Menu, which only appears on large screens */}
        <div className='menu'>
        {MenuItem.slice(0, 5).map((page) => (
          <NavLink
            to={page.to}
            className={({ isActive }) => isActive ? `${classes.active} navlink` : 'navlink'}
          >
            {page.title}
          </NavLink>

      ))}
        </div>

        {/* This button only shows up on small screens. It is used to open the mobile menu */}
        <button className='show-mobile-menu-button' onClick={toggleMobileMenu}>
          &#8801;
        </button>
      </div>

      {/* The mobile menu and the close button */}
      {isShown && <MobileMenu />}
      {isShown && (
        <button className='close-mobile-menu-button' onClick={toggleMobileMenu}>
          &times;
        </button>
      )}
    </>
  );
}

export default NavbarLower;